export default __webpack_public_path__ + "static/award-no-b3479b2fdd3469ec6ec7dd81cb110b71.png";